module.exports = __webpack_public_path__ + "img/bg-7@2x.e40a0367.jpg";